import React from 'react';
import BrowserWarningNotification from './BrowserWarningNotification';
import { isBrowserAllowed, BROWSER_WARNING } from './utils';
import { Browser } from './types';

type BrowserWarningNotificationItem = {
  type: typeof BROWSER_WARNING;
  isVisible: true;
  component: (response?: any) => React.ReactNode;
};

const useBrowserWarningNotifications = (
  minimumVersions: Record<Browser, number>,
  currentUserAlias: Nullable<string>,
): BrowserWarningNotificationItem[] => {
  const isSupportedBrowser = isBrowserAllowed(minimumVersions);

  if (!currentUserAlias || isSupportedBrowser) return [];

  return [
    {
      type: BROWSER_WARNING,
      isVisible: true,
      component: () => <BrowserWarningNotification />,
    },
  ];
};

export default useBrowserWarningNotifications;
